import axios from 'axios';

let resilienzaUrl = "https://res.mycompass.app";
let defaultTimeout = 25000;

export const init = (options) => {
    if(options.url) {
        resilienzaUrl = options.url;
    }
    if(options.defaultTimeout) {
        defaultTimeout = options.defaultTimeout;
    }
}

export const executeCall = (options) => {
    const out = {
        success: "false",
        message: "",
        data: {}
    }
    const originalUrl = options.url;
    return new Promise(function(resolve) {
        //const resilienzaUrl = "https://res.mycompass.app/";
        //const resilienzaUrl = "//10.4.187.70:8083";
        //const resilienzaUrl = "https://resilienza-col.int.compassonline.it"; //Server collaudo 10.1.88.33 https://resilienza-col.int.compassonline.it/
        //const resilienzaUrl = "http://172.30.251.253:8787"; //Server Mari
        if(!options.hasOwnProperty('url')) {
            out.message = "Url is mandatory";
            resolve(out);
            return false;
        }
        let frontendRequestUrl;
        try {
            frontendRequestUrl = new URL(options.url);
        } catch(e) {
            out.data = e;
            out.message = "Provided url is not valid";
            resolve(out);
            return false;
        }
        const app = options.app || "Compass";
        const flow = options.flow || "Standard";
        const aName = app + "/" + flow;
        const realOrigin = frontendRequestUrl.origin;
        let requestUrl = resilienzaUrl + frontendRequestUrl.pathname + frontendRequestUrl.search;
        options.url = requestUrl;
        options.method = options.method || "GET";
        options.data = options.data || {};
        options.headers = {
            ...options.headers,
            "X-Forward-To": realOrigin,
            "X-Retry": (options.retry || 0), //0 non riprovare, 1 o + indica i tentativi da effettuare
            "X-Application-Name": aName
        }
        options.timeout = options.timeout || defaultTimeout;
        axios(options)
          .then((response) => { //Chiamata a resilienza
            if(response.status == 200 && response.data.status == 1) {
                console.log("Resilienza ha risposto 200")
                if(options.hasOwnProperty('success')) {
                    response.data.data.log = "Resilienza 200";
                    options.success(response.data.data);
                    resolve();
                } else {
                    response.data.log = "Resilienza 200 non success";
                    out.data = response.data;
                    out.success = true;
                    resolve(out); 
                }
            } else {
                console.log("Resilienza ha risposto con un codice diverso da 200 provo il servizio standard")
                options.url = originalUrl;
                axios(options)
                    .then((response) => { //Fallback sull'url reale nel caso si sia rotta resilienza
                        if(response.status == 200) {
                            response.data.log = "Servizio standard";
                            options.success(response.data);
                            resolve();
                        } else {
                            response.data.log = "Servizio standard errore";
                            if(options.hasOwnProperty('error')) {
                                options.error(response.data);
                                resolve();
                            } else {
                                out.data = response;
                                out.message = "Api response code: " + response.status;
                                resolve(out);
                            }
                        }
                    })
                    .catch((err) => {
                        err.log = "Catch chiamata servizio";
                        options.error(err);
                        resolve()
                    })
            }
          })
          .catch(() => {
            options.url = originalUrl;
            axios(options)
                .then((response) => { //Fallback sull'url reale nel caso si sia rotta resilienza
                    if(response.status == 200) {
                        response.data.log = "Servizio standard";
                        options.success(response.data);
                        resolve();
                    } else {
                        response.data.log = "Servizio standard errore";
                        if(options.hasOwnProperty('error')) {
                            options.error(response.data);
                            resolve();
                        } else {
                            out.data = response;
                            out.message = "Api response code: " + response.status;
                            resolve(out);
                        }
                    }
                })
                .catch((err) => {
                    err.log = "Catch chiamata servizio";
                    options.error(err);
                    resolve()
                })
          })
    })
}

class ResilienzaClient {
    constructor() {
        this.call = executeCall;
    }
}

if(typeof window!="undefined") {
    window.resilienza = new ResilienzaClient();
}
export default ResilienzaClient;